import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const Kbd: ComponentStyleConfig = {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    flexShrink: 0,
    height: "20px",
    px: 1,
    py: 0.5,
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    lineHeight: "normal",
    border: "0.5px solid",
    borderColor: "base.border",
    bg: "gray.50",
    boxShadow: "xs",
    color: "text.tertiary",
    whiteSpace: "nowrap",
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
